/**
 * Registers a new block provided a unique name and an object defining its behavior.
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 */
import './style.scss';

/**
 * Internal dependencies
 */
import metadata from './block.json';
import attributes from './attributes';
import Edit from './edit';
import Save from './save';
import icon from './boxsloganIcon.svg';

/**
 * Every block starts by registering a new block type definition.
 */
registerBlockType( metadata.name, {
	attributes,
	/**
	 * @see ./edit.js
	 */
	edit: Edit,
	save: Save,
	icon: <img src={ icon } alt="Box slogan" height={ 16 } width={ 16 } />,
} );
